// src/main.jsx
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from './context/ThemeContext'
import { LangProvider } from './context/LangContext'
import App from './app/App'
import './styles/index.css'
import './styles/App.css'

// Punto de montaje principal
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <LangProvider>
          <App />
        </LangProvider>
      </ThemeProvider>
    </HelmetProvider>
  </StrictMode>
)

